import { formatRut } from "@abstract-cl/rut-ts";

const rutFormat = (rut: string | null | undefined): string | undefined => {
  return formatRut(rut);
};

export default rutFormat;
